// extracted by mini-css-extract-plugin
module.exports = {"main":"mainBg-module--main--24YOz","mainbg":"mainBg-module--mainbg--1_7Kc"};